import { render, staticRenderFns } from "./BookmarkManagement.vue?vue&type=template&id=5e5c522e&"
import script from "./BookmarkManagement.vue?vue&type=script&lang=js&"
export * from "./BookmarkManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports